import useSimpleDialog from '@eversports/react-components/logical/useSimpleDialog'
import { SimpleDialogContent, SimpleDialogTitle } from '@eversports/react-components/patterns/SimpleDialog'
import Dialog from '@eversports/react-components/primitives/Dialog'
import FormattedContent from '@eversports/react-components/primitives/FormattedContent'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { styled } from '@eversports/react-components/design-tokens/styled-components'

import Box from '@eversports/klimt-primitives/legacy/Box'
import { Localized } from '../../../localization/react'

const Content = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.03125rem;

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.03125rem;
  }

  ul {
    margin: 4px 0px;
    list-style: inside;

    li {
      line-height: 1.5rem;
    }

    li > p {
      display: inline;
    }
  }

  strong,
  b {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }
`
interface Props {
  cancellationConditions: string
}

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
})

const BookingDetailsCancellationConditions: React.FC<React.PropsWithChildren<Props>> = ({ cancellationConditions }) => {
  const classes = useStyles()
  const { showDialog, handleOpen, handleClose } = useSimpleDialog()

  const handleOpenClick = () => {
    handleOpen()
  }

  return (
    <>
      <Box
        component="button"
        onClick={handleOpenClick}
        sx={{ backgroundColor: 'transparent', width: 'fit-content', border: 'none', padding: 0 }}
      >
        <Text color="primary.main" size="small" className={classes.pointer}>
          <Localized id="cancellation-conditions" />
        </Text>
      </Box>
      <Dialog open={showDialog} onClose={handleClose}>
        <SimpleDialogTitle type="error" handleClose={handleClose}>
          <Localized id="cancellation-conditions" />
        </SimpleDialogTitle>
        <SimpleDialogContent>
          <FormattedContent htmlContent={cancellationConditions} WrapperComponent={Content} />
        </SimpleDialogContent>
      </Dialog>
    </>
  )
}

export default BookingDetailsCancellationConditions
